import { FunctionComponent } from 'react'
import { Duration } from '@/components/common/duration-select'
import KolDetailSection, {
  KolDetailSectionProps,
} from '@/components/kol/common/kol-detail-section'
import CollaborationValueEstimation from '@/components/kol/detail/collaboration-and-value/collaboration-value-estimation'
import SponsoredCollaboration from '@/components/kol/detail/collaboration-and-value/sponsored-collaboration'
import { useIntl } from '@/i18n/hooks/use-intl'
import { KolSchemaModel } from '@/types/schema/kol-schema'
import { Platform, PlatformShortcode } from '@/utils/convert-platform'

interface CooperationAndValueSectionProps {
  anchor: KolDetailSectionProps['header']['anchor']
  isFetchingKolInfo: boolean
  duration: Duration.ThreeMonths | Duration.SixMonths
  isKolInfoLocked: boolean
  kolInfo?: KolSchemaModel
  platform: Platform
  showMockData?: boolean
}

const CooperationAndValueSection: FunctionComponent<
  CooperationAndValueSectionProps
> = ({
  isFetchingKolInfo,
  kolInfo,
  duration,
  anchor,
  platform,
  isKolInfoLocked,
  showMockData,
}) => {
  const { formatMessage } = useIntl()

  if (platform.shortcode === PlatformShortcode.Twitter) {
    return null
  }

  return (
    <KolDetailSection
      header={{
        title: formatMessage({ id: 'kol:nav_cooperation_and_value' }),
        anchor,
      }}
    >
      <CollaborationValueEstimation
        duration={duration}
        isKolInfoLocked={isKolInfoLocked}
        kolInfo={kolInfo}
        loading={isFetchingKolInfo}
        platform={platform}
        showMockData={showMockData}
      />
      {![PlatformShortcode.Twitter, PlatformShortcode.TikTok].includes(
        platform.shortcode,
      ) && (
        <SponsoredCollaboration
          duration={duration}
          isFetchingKolInfo={isFetchingKolInfo}
          isKolInfoLocked={isKolInfoLocked}
          kolInfo={kolInfo}
          loading={isFetchingKolInfo}
          platform={platform}
          showMockData={showMockData}
        />
      )}
    </KolDetailSection>
  )
}

export default CooperationAndValueSection
